module.exports = __webpack_public_path__ + "img/the_grill.6918bf10.png";